import { Command } from 'commands/Commands';

export class ChangeWebsiteVisibility extends Command {
  priority: 100;
  type: string = 'ChangeWebsiteVisibility';
}
